import React, { useEffect, useState } from "react";
import { FiHome, FiLogOut } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import getIcons from "../../../utils/getIcon";
import { fetchFormData } from "../../../utils/options";
import topTost from "../../../utils/topTost";
import * as FiIcons from "react-icons/fi";
const Menus = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [menuList, setMenuList] = useState([]);
  const [permission, setPermission] = useState([]);
  const pathName = useLocation().pathname;
  const roleId = localStorage.getItem("roleId");

  // Get menus by role
  useEffect(() => {
    const getMenusByRole = async () => {
      if (!roleId) return;
      const formData = new FormData();
      formData.append("role_id", roleId);
      try {
        const result = await fetchFormData(
          "get-modules-by-role",
          formData,
          "POST"
        );
        if (result && result.data) {
          setMenuList(result.data);
          const moduleIds = result.data
            .flatMap((menu) => menu.sub_module_name || [])
            .map((sub) => sub.ModuleID);
        }
      } catch (error) {
        console.error("Menu load error:", error);
      }
    };

    getMenusByRole();
  }, [roleId]);

  // Highlight active menu
  useEffect(() => {
    if (pathName !== "/") {
      const [_, parent, child] = pathName.split("/");
      setOpenDropdown(parent);
    } else {
      setOpenDropdown("dashboard");
    }
  }, [pathName]);

  // Check permission before routing
  const handlePermissionCheck = async (e, moduleId, moduleName) => {
    const roleId = localStorage.getItem("roleId");

    if (!roleId || !moduleId ) {
      e.preventDefault();
    }

    const formData = new FormData();
    formData.append("role_id", roleId);
    formData.append("module_id", moduleId || 1);

    try {
      const result = await fetchFormData("get-permission", formData, "POST");
      const perm = result?.data;
      setPermission(perm);
    } catch (err) {
      e.preventDefault();
      console.error(" Permission check failed:", err);
    }
  };
  

  return (
    <ul className="sidebar-menu">
      <li className={`nxl-item ${pathName === "/home" ? "active" : ""}`}>
        <Link
          to="/home?id=1"
          className="nxl-link text-capitalize"
          onClick={(e) => handlePermissionCheck(e, 1, "Dashboard")}
        >
          <span className="nxl-micon">
            <FiIcons.FiHome />
          </span>
          <span className="nxl-mtext" style={{ paddingLeft: "4px" }}>
            Dashboard
          </span>
        </Link>
      </li>
      {menuList.length > 0 ? (
        menuList.map((menu, index) => {
          const Icon = FiIcons[menu.icon];

          const hasSubMenu =
            Array.isArray(menu.sub_module_name) &&
            menu.sub_module_name.length > 0;

          return (
            <li
              key={index}
              className={`nxl-item nxl-hasmenu ${
                openDropdown === menu.module_name ? "active nxl-trigger" : ""
              }`}
            >
              <div
                // to={hasSubMenu ? "#" : `/${menu.url}?id=${menuModuleId}`}
                style={{ cursor: "pointer" }}
                className="nxl-link"
                onClick={(e) => {
                  setOpenDropdown(
                    openDropdown === menu.module_name ? null : menu.module_name
                  );
                }}
              >
                <span className="nxl-micon">{Icon ? <Icon /> : null}</span>
                <span className="nxl-mtext" style={{ paddingLeft: "4px" }}>
                  {menu.module_name}
                </span>
              </div>

              {hasSubMenu && (
                <ul
                  className={`nxl-submenu ${
                    openDropdown === menu.module_name
                      ? "nxl-menu-visible"
                      : "nxl-menu-hidden"
                  }`}
                >
                  {menu.sub_module_name.map((sub, subIndex) => {
                    const SubIcon = FiIcons[sub.icons];
                    return (
                      <li
                        key={subIndex}
                        className={`nxl-item ${
                          pathName === `/${sub.url}` ? "active" : ""
                        }`}
                      >
                        <Link
                          className="nxl-link text-capitalize"
                          to={`/${sub.url}?id=${sub.ModuleID}`}
                          state={{ moduleId: sub.ModuleID }}
                          onClick={(e) =>
                            handlePermissionCheck(e, sub.ModuleID, sub.name)
                          }
                        >
                          <span className="nxl-micon fs-10">
                            {SubIcon ? <SubIcon /> : null}
                          </span>
                          {sub.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })
      ) : (
        <li style={{ padding: "8px", color: "#999", textAlign: "center" }}></li>
      )}

      {/* Logout Option */}
      <li
        className="nxl-item"
        onClick={() => {
          localStorage.clear();
          window.location.href = "/";
        }}
      >
        <Link to="#" className="nxl-link text-capitalize">
          <span className="nxl-micon">
            <FiLogOut />
          </span>
          <span className="nxl-mtext" style={{ paddingLeft: "4px" }}>
            Logout
          </span>
        </Link>
      </li>
    </ul>
  );
};

export default Menus;
